import React from 'react';
import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { envConfig } from '../../../environment';
import { Player } from 'video-react';
import ReactAudioPlayer from 'react-audio-player';



    class TaleAttachmentPreview extends React.Component {
      state = {
             item : {type:0},
             open :false
        }

        
  componentWillReceiveProps(nextProps) {
    //   console.log("props: ",nextProps)
       const open = nextProps.open;
       const item = nextProps.item;
       this.setState( {item, open}) ;
   
     }
     componentDidMount = ()=> {
        //   console.log("props: ",nextProps)
           const open = this.props.open;
           const item = this.props.item;
           this.setState( {item, open}) ;
       
         }

render(){
    let audioSrc = envConfig.apiUrl + this.state.item.filePath;
    return (
 
        <Dialog open={this.state.open} fullWidth={this.state.item.type===3  ? true :false} maxWidth="md">
              <DialogTitle>
    Masal Eki  Önizleme       </DialogTitle>
              <DialogContent>
                <DialogContentText>
                {this.state.item.type===3  ?
                           <Player
                              playsInline //  poster="/assets/poster.png"
                         
                              src={envConfig.apiUrl + this.state.item.filePath}
                            /> : this.state.item.type===2 ?
                              <ReactAudioPlayer
                               src={audioSrc}
                              autoPlay
                              controls
                            />
                
                          :null
                        
                        }
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.props.handleRequestClose} color="secondary">
                  Kapat
                </Button>
              </DialogActions>
            </Dialog>
    
     
      ); 
}
 
}


export default TaleAttachmentPreview;